__turbopack_context__.v({
  "article": "SalesList-module-scss-module__4YDcxG__article",
  "article__image": "SalesList-module-scss-module__4YDcxG__article__image",
  "content": "SalesList-module-scss-module__4YDcxG__content",
  "content__desktop": "SalesList-module-scss-module__4YDcxG__content__desktop",
  "content__header": "SalesList-module-scss-module__4YDcxG__content__header",
  "content__mobile": "SalesList-module-scss-module__4YDcxG__content__mobile",
  "elementsSlider": "SalesList-module-scss-module__4YDcxG__elementsSlider",
  "endDate": "SalesList-module-scss-module__4YDcxG__endDate",
  "root": "SalesList-module-scss-module__4YDcxG__root",
  "slide": "SalesList-module-scss-module__4YDcxG__slide",
  "title": "SalesList-module-scss-module__4YDcxG__title",
});
